import React from "react";
import { useSelector } from "react-redux";
import { Group, Checkbox, createStyles } from "@mantine/core";

const useStyles = createStyles((theme, { colors }) => ({
  answerWrap: {
    marginTop: 10,
  },
  answerStyle: {
    color: colors.default_text_color,
    fontSize: 16
  },
  radioStyle: {
    "&:checked": {
      backgroundColor: colors.primary_button_background_color,
      borderColor: colors.primary_button_background_color
    },
  }
}));

export default function SurveyMultiSelectInput({ options, selectedOptions, onChange }) {
  const colors = useSelector((state) => state.colors);

  const { classes } = useStyles({ colors });

  const _options = Array.isArray(options?.values) ? options.values : [];
  const _selectedOptions = Array.isArray(selectedOptions) ? selectedOptions : [];

  return (
    <>
      {_options.map((option, key) => {
        const checked = _selectedOptions.includes(option.value);
        return (
          <Group key={key}>
            <Checkbox
              checked={checked}
              label={option.name}
              styles={{
                root: classes.answerWrap,
                label: classes.answerStyle,
                input: classes.radioStyle,
              }}
              onChange={() => {
                if (typeof onChange === "function") {
                  const newOptions = checked ? _selectedOptions.filter(value => value !== option.value) :[..._selectedOptions, option.value];
                  onChange(newOptions);
                }
              }}
            />
          </Group>
        );
      })}
    </>
  );
}